import Tracker from '@deliveroo/events-client';

import { isServer } from 'lib/common/constants';

// Define some no-ops for when we're outside of browser-land.
let tracker = ({
  track: () => {},
  identify: () => {},
  reset: () => {},
  flush: () => Promise.resolve(),
  user: {},
} as unknown) as Tracker;

/**
 * Tracker relies on window and document, which will throw when
 * running on the server side, so we are conditionally instantiating
 * a new instance. Tracking should never be called from server-side
 * in any current workflow, so we should never be calling methods on
 * `undefined`.
 */
export default (() => {
  if (!isServer) {
    tracker = new Tracker({
      endpointUrl: '/api/track',
      deduplicator: (current, previous) => {
        /**
         * Catch "duplicate" page_loaded events that are just the querystring
         * being set and triggering a reload of the same page.
         */
        if (
          current.event_type === 'page_loaded' &&
          // eslint-disable-next-line camelcase
          previous?.event_type === 'page_loaded'
        ) {
          if (previous.properties.search === '') {
            if (previous.properties.path === current.properties.path) {
              return true;
            }
          }
        }

        return false;
      },
    });
  }

  return tracker;
})();
